<!-- 修改密码弹框 -->
<template>
  <div class="container">
    <el-dialog
      class="el-dialog3"
      title="机构管理员账号（手机号）改绑申请"
      :visible.sync="dialogVisible"
      width="25%"
      center
    >
      <div class="line1Box">
        <p class="p1" style="width: 1.2rem"><span>*</span>旧登录手机</p>
        <el-input
          size="small"
          style="width: 2.3rem"
          placeholder="验证旧密码"
        ></el-input>
      </div>
      <div class="line1Box">
        <p class="p1" style="width: 1.2rem">新登录手机</p>
        <el-input
          size="small"
          style="width: 2.3rem"
          placeholder="请设置新密码"
        ></el-input>
      </div>
      <div class="line1Box">
        <div class="btns5">获取验证码</div>
        <el-input
          size="small"
          style="width: 2.3rem"
          placeholder="请再次输入新密码"
        ></el-input>
      </div>
      <p class="p1" style="margin: 0.24rem 0">
        请输入更换机构管理员账号（手机号）的理由
      </p>
      <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="btns6" @click="dialogVisible = false"
          >确认申请更换成新的登录手机号</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    init() {
      this.dialogVisible = true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.el-dialog3 {
 .btns6 {
  width: 3.5rem;
  color: white;
  font-size: 0.16rem;
  font-family: "\9ED1\4F53";
  text-align: center;
  background: #ff6637;
  border-radius: 10px;
  cursor: pointer;
}
  .line1Box {
    display: flex;
    align-items: center;
    margin-top: 0.24rem;

    .btns5 {
      width: 1rem;
      height: 0.35rem;
      background: #3a62d7;
      font-size: 0.14rem;
      color: white;
      line-height: 0.35rem;
      text-align: center;
      margin-right: 0.1rem;
      cursor: pointer;
      margin-right: 0.2rem;
    }

    .p1 {
      font-size: 0.16rem;
      width: 1.5rem;
      position: relative;

      span {
        color: red;
        position: absolute;
        left: -8px;
        top: 0;
      }
    }
  }
}
</style>
